import * as React from 'react';
import { PriceType } from "../../../classes/price-type";
import { IOption } from '../../../classes/seating-option';
import { IExchangeTicket } from '../../../classes/ticket-exchange';
import PromoCodeContainer from '../../../common/promo-code/promo-code';
import { IPriceRangeModel, IAdditionalSeatingOptionModel } from '../../../filter/reducers/filter-reducers';
import { formatString } from '../../../helpers/string-format';
import { IAppSettingsModel } from '../../../reducers/fetch-settings-reducer';
import Cart from './cart';
import Subtotal from './subtotal';
import AdditionalNotes from '../../../common/notes/additional-notes';
import { ItemType } from '../../../classes/item-type';
import { IPromoCodeModel } from '../../../filter/reducers/promo-reducer';
import { ISeatMapModel } from '../../reducers/seatmap-reducer';
import { ICartModel } from '../../../cart/reducers/cart-reducer';
import { convertStringListToString } from '../../../helpers/array-helpers';
import { toggleSeatmapCart } from '../../../seatmap/actions/seatmap-actions';

interface IFiltersOverlayProps {
    appSettings: IAppSettingsModel;
    promoCodeModel: IPromoCodeModel;
    seatMapModel: ISeatMapModel;
    additionalSeatingOptionModel: IAdditionalSeatingOptionModel;
    cartModel: ICartModel;
    dispatch: any;

    itemType: ItemType;
    isMobile: boolean;
    hidingUpsell: boolean;
    showOverlay: boolean;
    showPromoCode: boolean;

    cartOverlayMessage: string;
    promoCodeTitle: string;
    additionalNotesTitle: string;

    seatmapCartText: string;

    selectedPriceTypes: Array<PriceType>;
}

interface IFiltersOverlayState {
    openPromoCode: boolean;
    openAdditionalNotes: boolean;
}

class FiltersOverlay extends React.Component<IFiltersOverlayProps, IFiltersOverlayState> {
    constructor(props) {
        super(props);

        this.state = {
            openPromoCode: false,
            openAdditionalNotes: false,
        }
    }

    shouldComponentUpdate(nextProps: IFiltersOverlayProps, nextState: IFiltersOverlayState) {
        return nextProps.showOverlay;
    }

    _togglePromoCodeShow() {
        this.setState({
            openPromoCode: !this.state.openPromoCode
        })
    }

    _toggleAdditionalNotesShow() {
        this.setState({
            openAdditionalNotes: !this.state.openAdditionalNotes
        })
    }

    _toggleSeatmapCart(evt) {
        evt.preventDefault();

        this.props.dispatch(toggleSeatmapCart());
    }

    handleClickOutside = evt => {
        if (this.props.showOverlay) {
            this.props.dispatch(toggleSeatmapCart());
        }
    };

    render() {
        const useTag = `<title id="expandAdditionalOptions">${formatString(this.props.appSettings.altText !== null ? this.props.appSettings.altText.expandSectionArrow : '', [this.props.appSettings.filterAdditionalSeatingOptionsTitle])}</title> <use xlink:href="#icon-arrow-down" />`;
        const xSvg = `<svg class="close-filters-icon"><use xlink:href="#icon-close" /></svg>`;
        const lastSectionClass = " overlay-filter-section-last";
        const showPromoCode = false; // disabled until we fix promo application logic after seats are already in the mini cart
        //const showPromoCode = this.props.itemType !== ItemType.Flex && this.props.itemType !== ItemType.Super && this.props.appSettings.enablePromoCodes;

        return (
            <div className="overlay-section overlay-section-cart">
                <div className="overlay-section-header">
                    <a href="#" onClick={(evt) => this._toggleSeatmapCart(evt)}>
                        <h2 className="heading-general">{this.props.seatmapCartText}</h2>
                        <div dangerouslySetInnerHTML={{ __html: xSvg }} ></div>
                    </a>

                </div>

                <div className="overlay-section-combined">
                    <Cart
                        selectedAdditionalOptionGroups={this.props.additionalSeatingOptionModel.additionalSeatingOptions.filter(optionGroup => optionGroup.groupSelected)}
                        cartSeats={this.props.cartModel.seats}
                        dispatch={this.props.dispatch}
                        itemId={this.props.appSettings.itemId}
                        selectedPriceTypes={this.props.selectedPriceTypes}
                        {...this.props.appSettings}
                        seatMapId={this.props.seatMapModel.seatmapId}
                        selectedSeatIds={convertStringListToString(this.props.seatMapModel.selectedSeats.map(s => s.seatId))}
                        allSeats={this.props.seatMapModel.levelSeats}
                        cartDisabled={this.props.cartModel.cartDisabled}
                        additionalNotes={this.props.additionalSeatingOptionModel.additionalNotes}
                    />

                    {showPromoCode ?
                        <div className={"overlay-filter-section" + (!this.props.appSettings.renderAdditionalNotes ? lastSectionClass : '')}>
                            <PromoCodeContainer />
                        </div>
                        : null}

                    {this.props.appSettings.renderAdditionalNotes ?
                        <div className={"overlay-filter-section" + lastSectionClass}>
                            <p className="caption-paragraph">
                                <button aria-expanded={this.state.openAdditionalNotes} className="filter-title" onClick={this._toggleAdditionalNotesShow.bind(this)}>
                                    {this.props.additionalNotesTitle}
                                    <svg className={"filters-section-heading-toggles-icon" + (this.state.openAdditionalNotes ? " toggled" : "")} aria-labelledby="expandAdditionalOptions" dangerouslySetInnerHTML={{ __html: useTag }} />
                                </button>
                            </p>
                            {this.state.openAdditionalNotes ?
                                <AdditionalNotes />
                                : null
                            }
                        </div>

                        : null
                    }

                </div>
                <div className="overlay-section-subtotal">
                    <Subtotal
                        selectedAdditionalOptionGroups={this.props.additionalSeatingOptionModel.additionalSeatingOptions.filter(optionGroup => optionGroup.groupSelected)}
                        cartSeats={this.props.cartModel.seats}
                        dispatch={this.props.dispatch}
                        itemId={this.props.appSettings.itemId}
                        {...this.props.appSettings}
                        cartDisabled={this.props.cartModel.cartDisabled}
                        additionalNotes={this.props.additionalSeatingOptionModel.additionalNotes}
                    />
                </div>


            </div>
        )
    }
}

export default FiltersOverlay;